import baseSignalRService from "./baseSignalRService";

/**
 * 全局 SignalR 服务基类实例，提供基础的消息收发和连接管理
 */
class AppSignalRService extends baseSignalRService {
    url = '/hubs/app/channel';
}

export default new AppSignalRService();
